import api from './api';

export const notificationService = {
    // Swipe action
    swipe: async (swipeData) => {
        return api.post('/card/swipe', swipeData);
    },

    // Mettre à jour les invitations acceptées
    updateAcceptedInvitations: async (userId, acceptedInvitations) => {
        return api.put(`/user/${userId}/update`, {
            acceptedInvitations
        });
    },

    // Récupérer les likes avec pagination
    getLikes: async (userId, page = 1, limit = 10) => {
        return api.get(`/like/userid/${userId}`, {
            params: { page, limit }
        });
    },

    // Récupérer les invitations avec pagination
    getInvitations: async (userId, page = 1, limit = 10) => {
        return api.get(`/like/invitations`, {
            params: {
                uid: userId,
                page,
                limit
            }
        });
    }
};
